const session_expired = {
    title: 'نشست منقضی شد',
    subtitle: 'نشست شما ممکن است منقضی شده باشد و اتصال قطع شده است. برای ورود مجدد به کنسول مدیریت روی دکمه زیر کلیک کنید.',
    button: 'ورود مجدد',
};
export default Object.freeze(session_expired);
